export enum ProgramParameters {
    DELINQUENCY = 'DELINQUENCY_BUCKET_CALC_STRATEGY',
}
